<template>
  <!-- 用户管理-用户限制消费-编辑限制消费弹窗 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="编辑用户消费限制"
      width="350px"
      @close="closeDialog"
    >
      <el-form
        :model="formData"
        v-if="formData"
        ref="formData"
        label-width="120px"
        size="small"
        :rules="taskRules"
      >
        <el-form-item prop="limit_amount" label="最大限制金额">
          <el-select
            class="select-type"
            v-model="formData.limit_amount"
            placeholder="请选择金额"
            :popper-append-to-body="false"
          >
            <el-option :value="100" label="100元"></el-option>
            <el-option :value="200" label="200元"></el-option>
            <el-option :value="500" label="500元"></el-option>
            <el-option :value="3000" label="3000元"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="continuous_days" label="限制天数">
          <el-select
            class="select-type"
            v-model="formData.continuous_days"
            placeholder="请选择天数"
            :popper-append-to-body="false"
          >
            <el-option :value="1" label="1天"></el-option>
            <el-option :value="7" label="7天"></el-option>
            <el-option :value="10" label="10天"></el-option>
            <el-option :value="30" label="30天"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="status" label="状态">
          <el-select
            class="select-type"
            v-model="formData.status"
            placeholder="请选择天数"
            :popper-append-to-body="false"
          >
            <el-option :value="1" label="限制中"></el-option>
            <el-option :value="0" label="已解除"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { patchData, postData, getApiData, patchApiData, postApiData, delApiData } from '@/http'
export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      formData: {//表单数据
        limit_amount: undefined,//限制金额
        continuous_days: undefined,//限制天数
        status: undefined,//限制天数
      },
      taskRules: {//添加表单验证
        limit_amount: [
          {
            required: true,
            message: '请输入限制金额',
            trigger: 'blur'
          }
        ],
        continuous_days: [
          {
            required: true,
            message: '请输入限制天数',
            trigger: 'blur'
          }
        ],
        status: [
          {
            required: true,
            message: '请选择状态',
            trigger: 'blur'
          }
        ],
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    dialogInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val && this.dialogInfo) {
        //打开弹窗赋值
        this.formData = this.dialogInfo
      }
    }
  },
  created() {
  },
  methods: {
    submit() {
      //保存
      //表单验证后发起请求
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          this.buttonLoading = true
          let params = this.formData
          patchApiData('limit_consumption', params).then(res => {
            if (res) {
              this.$message.success("编辑成功")
              this.closeDialog()//关闭弹窗
              this.$emit("refresh")//刷新数据
            } else {
              this.$message.error("编辑失败")
            }
          }).finally(() => {
            this.buttonLoading = false
          })
        }
      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }
}
</script>
<style lang="less" scoped>
</style>